import { createAsyncThunk, createSlice, isAsyncThunkAction, PayloadAction} from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { LocationStateClass } from "./interfaces/LocationStateClass";
import { Await } from "react-router-dom";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: LocationStateClass = {
    isLoading: true,
    LocationList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'AccountLocation',
    pageNo: 1,
    search: '',
    pageSize: 10
};

interface IThunkApi {
    state: {
        location: LocationStateClass
    }
};

export const getAccountLocationsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Location/v2/getAccountLocations",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Locations', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

    export const getAccountLocationByAccountLocationIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Location/v2/getAccountLocationByAccountLocationId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Locations/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
    export const addAccountLocationAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Location/v2/addAccountLocation',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Locations/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
    export const updateAccountLocationAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Location/v2/updateAccountLocation',
        async (arg, thunkApi) => {
            const { AccountLocationId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Locations/' + AccountLocationId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountLocationAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Location/v2/deleteAccountLocation",
    async(arg,thunkApi) =>{
        const response = await fetchAPI('api/v2/Locations/' + arg,'Delete','',true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json =await response.json();
        return json;
    }
)
export const DeleteSelectedAccountLocationAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Location/v2/DeleteSelectedAccountLocation",
    async(arg,thunkApi) =>{
        const response = await fetchAPI('api/v2/Locations/DeleteSelected/','Delete',arg,true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json =await response.json();
        return json;
    
    }
)

export const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.LocationList.findIndex((item) => item.AccountLocationId == action.payload);
            const newArray = [...state.LocationList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.LocationList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.LocationList.findIndex((item) => item.AccountLocationId == action.payload);
            const newArray = [...state.LocationList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.LocationList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.LocationList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.LocationList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.LocationList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.LocationList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.LocationList;
            state.LocationList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getAccountLocationsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountLocationsAsync.fulfilled, (state,{payload}) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.LocationList = [];
                } else {
                    state.LocationList = payload.Data;
                    state.LocationList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountLocationsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            

            .addCase(getAccountLocationByAccountLocationIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountLocationByAccountLocationIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
                state.isLoading = false;
            })
            .addCase(getAccountLocationByAccountLocationIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(addAccountLocationAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountLocationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountLocationAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountLocationAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountLocationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountLocationAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(deleteAccountLocationAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountLocationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountLocationAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(DeleteSelectedAccountLocationAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DeleteSelectedAccountLocationAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(DeleteSelectedAccountLocationAsync.rejected, (state) => {
                state.status = 'failed';
            })
            
    }

});

export const {resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination} = locationSlice.actions
export const locationState = (state: RootState) => state.location
export default locationSlice.reducer
